import { FeatureFlag, featureFlagsStaticData } from './featureFlags';

// This is preserved in this const folder so that the rest of the app and continue importing it
export const featureFlagKeys = Object.fromEntries(
  Object.keys(featureFlagsStaticData).map((featureFlagKey) => [
    featureFlagKey,
    featureFlagKey,
  ]),
) as { [K in FeatureFlag]: K };
